/**
 * Cálculo de progresso para a barra do Welcome Wizard
 * Usa fórmula de desaceleração para dar a impressão de "quase lá"
 */

// Fração do RESTANTE consumida a cada passo
// Ajustável globalmente — mexer aqui muda o comportamento de todas as barras
export const STEP_FACTOR = 0.20;

/**
 * Calcula o percentual de progresso (0-100) para um dado passo
 * 
 * @param {number} stepIndex - Índice do passo (base 1)
 * @returns {number} Percentual de progresso (0-100)
 * 
 * Exemplos com STEP_FACTOR = 0.20:
 *   stepIndex=1 → 20%
 *   stepIndex=2 → 36%
 *   stepIndex=3 → 49%
 *   stepIndex=5 → 67%
 *   stepIndex=12 → 93%
 */
export const calculateProgress = (stepIndex) =>
  Math.round((1 - Math.pow(1 - STEP_FACTOR, stepIndex)) * 100);

/**
 * Getter para o texto de motivação da barra
 * Exibir apenas quando progresso >= 80%
 */
export const getProgressMotivation = (progress) =>
  progress >= 80 ? 'Quase lá! 🙌' : null;
